import { useState, useEffect, useCallback } from 'react';
import { getDemreConfig } from '../api/requests/demreConfig';

/**
 * El codigo DEMRE tiene su propio switch (`demre-config.enabled`), separado del
 * de SIES: son dos cosas distintas y cada tenant las habilita por su cuenta.
 */
export const useDemreConfig = () => {
  const [demreEnabled, setDemreEnabled] = useState<boolean>(false);
  const [mounted, setMounted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const fetchConfig = useCallback(async () => {
    if (loading) {
      return;
    }
    setError(undefined);
    setLoading(true);
    const { data, error } = await getDemreConfig();
    setDemreEnabled(!!data?.enabled);
    setError(error ? 'FETCH_ERROR' : undefined);
    setLoading(false);
  }, [loading]);

  useEffect(() => {
    if (!mounted) {
      fetchConfig();
      setMounted(true);
    }
  }, [mounted, fetchConfig]);

  return {
    demreEnabled,
    error,
    loading,
    mounted,
  };
};
